import React, { useEffect, useState } from 'react';
import './ChangeOrderDetails.css';
import loginLogo from '../../../../assets/img/login-logo2.svg';
import logoHover from '../../../../assets/img/login-logohover.svg';
import logoHover2 from '../../../../assets/img/login-logohover2.svg';
import leftArrow from '../../../../assets/img/white-left-icon.svg';
import closeCross from '../../../../assets/img/close-cross.svg';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Header from '../../../../components/Header';
import attechFile2 from '../../../../assets/img/ios-attach2.svg';
import Tippy from '@tippyjs/react';
import delete3 from 'assets/img/delete4.svg';
import documentFile from '../../../../assets/img/document-file.svg';

import aistart from '../../../../assets/img/aistart.svg';
import edit4 from '../../../../assets/img/edit4.svg';
import APIServices from 'services/APIServices';
import {
  calculateTimeAgo,
  MAX_FILE_SIZE,
  selectLoader,
  titleLimit,
  validateChangeOrder,
  validateForm
} from 'utils/Helpers';
import appToast, { TOAST_TYPE } from 'utils/AppToast';
import ChangeOrderOptionSelector from './ChangeOrderOptionSelector';
import CreateEstimate from './CreateEstimate';
import EstimationHeader from './EstimationHeader';
import { fetchProjectTeamMembers } from 'utils/fetchData';
import { useAuth } from 'contexts/AuthContext';

const ChangeOrderDetails = () => {
  const navigate = useNavigate();
  const { user, isOwner } = useAuth();
  const { requestId } = useParams();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const projectId = queryParams.get('projectId');
  const changeReqId = queryParams.get('changeReqId');
  const qouteId = queryParams.get('qouteId');

  const isAddQuoteFlow = queryParams.get('isAddQuoteFlow') === 'true';

  const isEditQuoteFlow = queryParams.get('isEditQuoteFlow') === 'true';

  const isEditChangeOrderFlow = queryParams.get('isEditChangeOrderFlow') === 'true';

  const isCreateMode = !requestId;
  const [changeOrderId, setChangeOrderId] = useState(null);
  const isEditing = (requestId || changeOrderId) && !isAddQuoteFlow;
  const [changeOrder, setChangeOrder] = useState(null);
  const [parentId, setParentId] = useState('');
  const [files, setFiles] = useState([]);
  const [filestoDelete, setFilesToDelete] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isManualFlow, setIsManualFlow] = useState(false);
  const [isPreview, setIsPreview] = useState(false);
  const [projectTeam, setProjectTeam] = useState([]);
  // const [isEditing, setEditing] = useState(false);
  const [formData, setFormData] = useState({
    attachments: [],
    description: '',
    title: '',
    requestType: 'change_order'
  });
  const [generatedOptions, setGeneratedOptions] = useState(null);
  const [isCreated, setIsCreated] = useState(false);
  const [showStep2, setShowStep2] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [pageLoading, setPageLoading] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [industryOptions, setIndustryOptions] = useState([]);
  const [currentQuoteId, setCurrentQuoteId] = useState(qouteId || '');
  useEffect(() => {
    if (projectId) {
      fetchProjectTeamMembers(projectId, setProjectTeam);
    }
  }, [projectId]);

  useEffect(() => {
    if (isCreateMode) {
      // setEditing(false);
      setFormData({
        title: '',
        description: '',
        attachments: []
      });
      setFiles([]);
    }
  }, [isCreateMode]);

  useEffect(() => {
    if (!requestId) return;

    const fetchData = async () => {
      setPageLoading(true); // ✅ START LOADER

      try {
        const res = await APIServices.get(`/project-requests/detail/${requestId}?page=1&limit=10`);

        if (res.data) {
          setChangeOrder(res.data);
          setChangeOrderId(res.data._id); // ✅ set change order ID for later use
          setParentId(res?.data?.parentRequestId?._id || res.data._id); // ✅ set parent ID for later use
        }
      } catch (error) {
        console.error('Error fetching change order:', error);
      } finally {
        setPageLoading(false); // ✅ STOP LOADER
      }
    };

    fetchData();
  }, [requestId]);

  useEffect(() => {
    setPageLoading(true);
    if (isEditQuoteFlow) {
      setCurrentStep(3); // ✅ directly open CreateEstimate
    }
    if (!isEditChangeOrderFlow && !isAddQuoteFlow) {
      setPageLoading(false);
    }
  }, [isEditQuoteFlow]);

  const fetchIndustryOptions = async () => {
    try {
      const res = await APIServices.get(`/user-settings/business-vertical/industry-options`);

      setIndustryOptions(res.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (isOwner) {
      fetchIndustryOptions();
    }
  }, [currentStep === 2]); // ✅ fetch industry options only for owners and when on step 2

  useEffect(() => {
    if (changeOrder) {
      // setEditing(true);
      setFormData({
        title: changeOrder.title || '',
        description: changeOrder.description || '',
        attachments: changeOrder.attachments || []
      });
      setFiles(changeOrder.attachments || []);
    }
  }, [changeOrder]);

  const handleBack = () => {
    // ✅ preview → back to edit mode

    if (currentStep === 3 && isPreview) {
      setIsPreview(false);
      return;
    }

    if (currentStep === 3 && currentQuoteId && !isPreview) {
      window.close();
      return;
    }
    // ✅ if edit quote flow and inside estimate screen → close tab
    if (currentStep === 3 && isEditQuoteFlow) {
      window.close();
      return;
    }

    // ✅ normal step navigation
    if (currentStep > 1 && !isEditQuoteFlow) {
      // ✅ manual flow: step 3 should return to step 1
      if (currentStep === 3 && isManualFlow) {
        setGeneratedOptions(null);
        setCurrentStep(1);
        return;
      }

      // ✅ clear stale AI data
      if (currentStep === 2) {
        setGeneratedOptions(null);
      }

      setCurrentStep((prev) => prev - 1);
      return;
    }
    // ✅ close tab instead of navigate back
    window.close();
  };

  const handleSubmit = async () => {
    if (!validateChangeOrder(formData, setErrors)) return;

    setLoading(true);

    const formDataToSend = new FormData();

    formDataToSend.append('title', formData.title);
    formDataToSend.append('description', formData.description);
    formDataToSend.append('requestType', 'change_order');
    formDataToSend.append('projectId', projectId);
    files.forEach((file) => {
      formDataToSend.append('attachments', file);
    });

    if (isEditing && filestoDelete.length) {
      formDataToSend.append('deletedAttachments', filestoDelete.join(','));
    }

    try {
      const response = isEditing
        ? await APIServices.put(`/project-requests/${requestId ? requestId : changeOrderId}`, formDataToSend, {
            'Content-Type': 'multipart/form-data'
          })
        : await APIServices.post(`/project-requests`, formDataToSend, {
            'Content-Type': 'multipart/form-data'
          });

      appToast(isEditing ? 'Updated successfully' : 'Created successfully', TOAST_TYPE.SUCCESS);
      if (response?.data) {
        setChangeOrderId(response?.data?._id);
        setParentId(response?.data?.parentRequestId || response?.data?._id); // ✅ set parent ID for later use
        setFormData({
          title: response?.data?.title || '',
          description: response?.data?.description || '',
          attachments: response?.data?.attachments || []
        });
        setFiles(response?.data?.attachments || []);
        if (!isEditing) {
          setIsCreated(true);
        } else if (isEditChangeOrderFlow) {
          window.close();
        }
      }
    } catch (err) {
      console.error(err);
      appToast('An error occurred', TOAST_TYPE.ERROR);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    handleFiles(selectedFiles);
  };

  const handleFiles = (selectedFiles) => {
    const totalFiles = files.length + selectedFiles.length;

    if (totalFiles > 5) {
      appToast('You can upload a maximum of 5 files.', TOAST_TYPE.ERROR);
      return;
    }

    const totalSize =
      files.reduce((sum, file) => sum + (file.size || 0), 0) + selectedFiles.reduce((sum, file) => sum + file.size, 0);

    if (totalSize > 40 * 1024 * 1024) {
      appToast('The total size of uploaded files should not exceed 40MB.', TOAST_TYPE.ERROR);
      return;
    }

    const validFiles = [];
    const errors = [];

    selectedFiles.forEach((file) => {
      if (file.size > MAX_FILE_SIZE) {
        errors.push(`${file.name} exceeds the maximum file size of 20MB.`);
      } else {
        validFiles.push(file);
      }
    });

    if (errors.length > 0) {
      appToast(errors.join(' '), TOAST_TYPE.ERROR);
    }

    if (validFiles.length > 0) {
      setFiles((prev) => [...prev, ...validFiles]);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const droppedFiles = Array.from(e.dataTransfer.files);

    handleFiles(droppedFiles);
  };

  const handleRemoveFile = (index) => {
    if (isEditing) {
      let fileToDelete = files.filter((_, i) => i == index);
      console.log(fileToDelete[0]._id);
      if (fileToDelete && fileToDelete.length > 0 && fileToDelete[0]._id) {
        setFilesToDelete((prevFiles) => [...prevFiles, fileToDelete[0]._id]);
      }
    }
    const updatedFiles = files.filter((_, i) => i !== index);
    setFiles(updatedFiles);
  };

  return (
    <div className="wrapper estimate-wrapper">
      <EstimationHeader
        handleBack={handleBack}
        currentStep={currentStep}
        isEditing={isEditChangeOrderFlow}
        isEditQuoteFlow={isEditQuoteFlow}
        isPreview={isPreview}
        currentQuoteId={currentQuoteId}
      />
      {pageLoading ? (
        <div className="nodata-loader">{selectLoader(70)}</div>
      ) : (
        <div className="main-content">
          <div className="container">
            {currentStep === 1 && (
              <>
                <div className="changeOder-card">
                  <div className="row mb-10">
                    <div className="col-lg-12 col-md-12">
                      <div className="form-group">
                        <label>Estimate Title</label>
                        <input
                          maxLength={titleLimit}
                          // disabled={isAddQuoteFlow} // ✅ disable title editing in quote edit flow
                          type="text"
                          className={`form-control ${errors.title ? 'error-border' : ''}`}
                          name="title"
                          placeholder="Title"
                          value={formData?.title || ''}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row mb-10">
                    <div className="col-lg-12">
                      <div className="form-group">
                        <label>What would you like us to do?</label>
                        <textarea
                          // disabled={isAddQuoteFlow}
                          className={`form-control ${errors.description ? 'error-border' : ''}`}
                          name="description"
                          placeholder="Description"
                          value={formData?.description || ''}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                  </div>
                  {/* <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group">
                        <label>Attachments (Optional)</label>
                        <div className={`cardbg-form-group ${isDragging ? 'drag-active' : ''}`}>
                          <div
                            className={`attech-file-cover`}
                            onDrop={(e) => {
                              handleDrop(e);
                              setIsDragging(false);
                            }}
                            onDragOver={(e) => e.preventDefault()}
                            onDragEnter={() => setIsDragging(true)}
                            onDragLeave={() => setIsDragging(false)}>
                            <img src={attechFile2} alt="Attach" className="attechFile" />

                            <a className="attech-btn">
                              <p>Drop files here or click to upload</p>

                              <label className="add-btn-text cursor_pointer">
                                <input
                                  // disabled={isAddQuoteFlow}
                                  type="file"
                                  multiple
                                  accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                                  onChange={handleFileChange}
                                  style={{ display: 'none' }}
                                />
                                + Screenshots, mockups, or reference documents
                              </label>
                            </a>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="file_grid_row row">
                    {files?.map((file, index) => (
                      <div className="col-lg-3 col-md-6 col-sm-6" key={file._id}>
                        <div className="file_card">
                          <div className="file_preview">
                            <a href={file.url || URL.createObjectURL(file)} target="_blank">
                              <img src={documentFile} alt="File" className="documentFile" />
                            </a>
                          </div>

                          <div className="file_info">
                            <div className="file_info_content">
                              <div className="file_name">
                                <div className="file_name">{file.name || file.originalName}</div>
                              </div>
                              <div className="file_time">{calculateTimeAgo(file.uploadedAt)}</div>
                            </div>
                            <img src={delete3} onClick={() => handleRemoveFile(index)} />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div> */}
                </div>
                {!isAddQuoteFlow && (
                  <div className="changeOder-btn-cover">
                    <button className={`btn-black btn-submit w-100 marginbottom30`} onClick={handleSubmit}>
                      {loading ? selectLoader(30) : isEditing ? 'Update' : 'Save'}
                    </button>
                  </div>
                )}
                {!isEditChangeOrderFlow && (
                  <>
                    {!isAddQuoteFlow && (
                      <div className="separator-wrapper">
                        <span className="separator">How would you like to create your estimate?</span>
                      </div>
                    )}

                    <div className="changeOder-btn-cover">
                      <button
                        className={`btn-green ${!isCreated && !isAddQuoteFlow ? 'disabled-btn' : ''}`}
                        onClick={() => setCurrentStep(2)}
                        // disabled={!isCreated && !isAddQuoteFlow}
                      >
                        <img src={aistart} /> Generate Estimate using AI
                      </button>

                      <button
                        className={`btn-black ${!isCreated && !isAddQuoteFlow ? 'disabled-btn' : ''}`}
                        onClick={() => {
                          setGeneratedOptions(null);
                          setIsManualFlow(true); // ✅ mark manual flow
                          setCurrentStep(3);
                        }}
                        // disabled={!isCreated && !isAddQuoteFlow}
                      >
                        <img src={edit4} /> Manual Creation
                      </button>
                    </div>
                  </>
                )}
              </>
            )}
            {currentStep === 2 && (
              <>
                <ChangeOrderOptionSelector
                  projectRequestId={requestId ? requestId : changeOrderId}
                  onGenerated={(data) => {
                    setGeneratedOptions(data);
                    setCurrentStep(3);
                  }}
                  industryOptions={industryOptions}
                />
              </>
            )}
            {currentStep === 3 && (
              <>
                <CreateEstimate
                  currentQuoteId={currentQuoteId}
                  setCurrentQuoteId={setCurrentQuoteId}
                  changeOrderDetails={{
                    ...changeOrder,
                    title: formData.title,
                    description: formData.description,
                    attachments: files
                  }}
                  data={generatedOptions}
                  changeReqId={changeReqId ? changeReqId : isEditing ? parentId : changeOrderId}
                  parentId={parentId}
                  qouteId={qouteId}
                  projectId={projectId}
                  isManualFlow={isManualFlow}
                  isPreview={isPreview}
                  setIsPreview={setIsPreview}
                  projectTeam={projectTeam}
                  onSwitchToAI={() => {
                    setIsManualFlow(false);
                    setCurrentStep(2);
                  }}
                />
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ChangeOrderDetails;
